import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import MDTypography from "dashboard/components/MDTypography";

const styles = {
  tableContainer: {
    border: '1px solid #e0e0e0',
    marginTop: '8px',
    borderRadius : 0
  },
  tableRowEven: {
    backgroundColor: '#f5f5f5',
  },
  tableRowOdd: {
    backgroundColor: '#ffffff',
  },
  tableCell: {
    border: '1px solid #e0e0e0',
    padding: '8px',
  },
};

const DetailsTable = ({ details, DOMPurify, parse  }) => {
  return (
     <TableContainer component={Paper} sx={styles.tableContainer}>
      <Table>
        <TableBody>
          {details && details.map((detail, index) => (
            <TableRow
              key={index}
              sx={index % 2 === 0 ? styles.tableRowEven : styles.tableRowOdd}
            >
              <TableCell sx={styles.tableCell}>
                <MDTypography sx={{color :({palette  : {dark,mode}}) =>  mode === "light" ? "text" : dark.main, mb:0}} variant="h6" gutterBottom>
                  {detail.label}
                </MDTypography>
              </TableCell>
              <TableCell sx={styles.tableCell}>
                <MDTypography sx={{color :({palette  : {dark,mode}}) =>  mode === "light" ? "text" : dark.main, mb:0}} variant="body2" gutterBottom>
                  {parse(DOMPurify.sanitize(detail.description))}
                </MDTypography>
              </TableCell>
              <TableCell sx={styles.tableCell}>
                <MDTypography sx={{color :({palette  : {dark,mode}}) =>  mode === "light" ? "text" : dark.main, mb:0}} variant="body2" gutterBottom>
                  {parse(DOMPurify.sanitize(detail.details))}
                </MDTypography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer> 
  );
};

export default DetailsTable;
